// extracted by mini-css-extract-plugin
export var activeDot = "_65-c";
export var buttonContainer = "_65-9";
export var channelButton = "_65-a";
export var clickable = "_65-d";
export var content = "_65-0";
export var contentFull = "_65-2";
export var contentThird = "_65-1";
export var contentWrapper = "_65-7";
export var description = "_65-5";
export var heightShort = "_65-f";
export var image = "_65-3";
export var imageContainer = "_65-4";
export var selectButton = "_65-e";
export var spinnerContainer = "_65-b";
export var titleContent = "_65-8";
export var titleWrapper = "_65-6";